// Copyright © 2021 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export default Object.freeze({
  ACTIVATION_MODE: 'activation-mode',
  ADR_ACK_DELAY: 'adr-ack-delay',
  ADR_ACK_LIMIT: 'adr-ack-limit',
  ADR_MARGIN: 'adr-margin',
  ADR_USE: 'adr-use',
  APP_KEY: 'appkey',
  APP_SESSION_KEY: 'application-session-key',
  BASIC_AUTH: 'basic-auth',
  BEACON_FREQUENCY: 'beacon-frequency',
  CLASS_B_TIMEOUT: 'class-b-timeout',
  CLASS_C_TIMEOUT: 'class-c-timeout',
  CLASSES: 'classes',
  CLAIM_AUTH_CODE: 'claim-auth-code',
  CLUSTER_SETTINGS: 'cluster-settings',
  DATA_RATE_OFFSET: 'data-rate-offset',
  DEV_EUI: 'deveui',
  DEVICE_ADDRESS: 'device-address',
  DEVICE_BRAND: 'device-brand',
  DEVICE_DESCRIPTION: 'device-description',
  DEVICE_FIRMWARE_VERSION: 'device-firmware-version',
  DEVICE_HARDWARE_VERSION: 'device-hardware-version',
  DEVICE_ID: 'device-id',
  DEVICE_MODEL: 'device-model',
  DEVICE_NAME: 'device-name',
  DISABLE_PACKET_BROKER_FORWARDING: 'disable-packet-broker-forwarding',
  ENFORCE_DUTY_CYCLE: 'duty-cycle',
  FACTORY_PRESET_FREQUENCIES: 'factory-preset-frequencies',
  FRAME_COUNTER_WIDTH: 'frame-counter-width',
  FREQUENCY_PLAN: 'frequency-plan',
  GATEWAY_ATTRIBUTES: 'gateway-attributes',
  GATEWAY_DESCRIPTION: 'gateway-description',
  GATEWAY_EUI: 'gateway-eui',
  GATEWAY_ID: 'gateway-id',
  GATEWAY_LOCATION: 'gateway-location',
  GATEWAY_NAME: 'gateway-name',
  GATEWAY_PLACEMENT: 'gateway-placement',
  GATEWAY_STATUS: 'gateway-status',
  JOIN_EUI: 'joineui',
  JOIN_SERVER: 'join-server',
  LORAWAN_VERSION: 'lorawan-version',
  MAX_DUTY_CYCLE: 'max-duty-cycle',
  NETWORK_KEY: 'network-key',
  NETWORK_RX_DEFAULTS: 'network-rx-defaults',
  NETWORK_SESSION_KEY: 'network-session-key',
  PING_SLOT_DATA_RATE_INDEX: 'ping-slot-data-rate-index',
  PING_SLOT_FREQUENCY: 'ping-slot-frequency',
  PING_SLOT_PERIODICITY: 'ping-slot-periodicity',
  REGIONAL_PARAMETERS: 'regional-parameters',
  REQUIRE_AUTHENTICATED_CONNECTION: 'require-authenticated-connection',
  RESET_MAC: 'reset-mac',
  RESETS_F_CNT: 'resets-f-cnt',
  RX1_DELAY: 'rx1-delay',
  RX2_DATA_RATE_INDEX: 'rx2-data-rate-index',
  RX2_FREQUENCY: 'rx2-frequency',
  SCHEDULE_ANYTIME_DELAY: 'schedule-anytime-delay',
  SCHEDULE_DOWNLINK_LATE: 'schedule-downlink-late',
  SET_CLAIM_AUTH_CODE: 'set-claim-auth-code',
  SKIP_PAYLOAD_CRYPTO_OVERRIDE: 'skip-payload-crypto-override',
  STATUS_COUNT_PERIODICITY: 'status-count-periodicity',
  STATUS_TIME_PERIODICITY: 'status-time-periodicity',
  UPDATE_LOCATION_FROM_STATUS: 'update-location-from-status',
  COOLDOWN_WINDOW: 'cooldown-window',
  DEDUPLICATION_WINDOW: 'deduplication-window',
  DEV_ADDRESS_PREFIXES: 'dev-address-prefixes',
})
